module.exports = __webpack_public_path__ + "static/media/26.489464dc.png";